import React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { RouterError } from '~src/bootstrap/routerHelpers/RouterError';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { GroupSetSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { GroupSetSpaceProvider, GroupSetSpaceProviderProps } from './GroupSetSpaceProvider';

export interface SpaceRouteParams {
  readonly id: string;
}

export interface GroupSetRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface GroupSetSpaceRouterOwnProps {
  readonly siteName: string;}

export interface GroupSetSpaceRouterStateProps {
  readonly urls: SpacesSiteUrls;
  readonly routerReactKey: number;
}

export type GroupSetSpaceRouterProps = GroupSetSpaceRouterOwnProps & GroupSetSpaceRouterStateProps;

export class GroupSetSpaceRouterComponent extends React.PureComponent<GroupSetSpaceRouterProps> {

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.groupSetGroupsPath(':id')} render={this.provider('groups')} />
        <Route render={this.error} />
      </Switch>
    );
  }

  private provider = (subspaceName: GroupSetSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (props: GroupSetRouteComponentProps): JSX.Element => {
      const groupSetSpaceProps: GroupSetSpaceProviderProps = {
        urls: this.props.urls,
        siteName: this.props.siteName,
        subspaceName,
        routeLocationSearch: props.location.search,
        routeLocationPath: null,
        groupSetId: props.match.params.id
      };

      return <GroupSetSpaceProvider {...groupSetSpaceProps}/>;
    };
  };

  private error = (_props: RouteComponentProps): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  };
}

const mapStateToProps: MapStateToProps<GroupSetSpaceRouterStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  routerReactKey: state.routerSpaceReactKey
});

export const GroupSetSpaceRouter: React.ComponentClass<GroupSetSpaceRouterOwnProps>
  = connect(mapStateToProps)(GroupSetSpaceRouterComponent);
